import React from "react";

const Main_Dashboard = React.lazy(() =>
  import("./components/main_dashboard/Main_Dashboard"),
);

const Profile = React.lazy(() => import("./components/header/profile/Profile"));

const Notification = React.lazy(() =>
  import("./components/header/notification/Notification"),
);

const Activation = React.lazy(() =>
  import("./components/activation/Activation"),
);

// const Select_Products = React.lazy(() =>
//   import("./components/activation/select-products/Select_Products"),
// );

const Select_Products = React.lazy(() =>
  import(
    "./components/activation/invest-again/select-products/Select_Products"
  ),
);

const KYC = React.lazy(() => import("./components/kyc/KYC"));

const Add_Member = React.lazy(() =>
  import("./components/add-member/Add_Member"),
);

const My_Team = React.lazy(() => import("./components/my-team/My_Team"));

const Binary_Tree = React.lazy(() =>
  import("./components/binary-tree/Binary_Tree"),
);

const Activate_Member = React.lazy(() =>
  import("./components/activate-member/Activate_Member"),
);

const Income_Reports = React.lazy(() =>
  import("./components/income-reports/Income_Reports"),
);

const Wallet = React.lazy(() => import("./components/wallet/Wallet"));

const Add_Funds = React.lazy(() => import("./components/add-funds/Add_Funds"));

const Funds_Add = React.lazy(() =>
  import("./components/add-funds/fund-requests/funds-add/Funds_Add"),
);

const Withdrawals = React.lazy(() =>
  import("./components/withdrawals/Withdrawals"),
);

const New_Request = React.lazy(() =>
  import("./components/withdrawals/new-request/New_Request"),
);

const My_Orders = React.lazy(() => import("./components/my-orders/My_Orders"));

const routes = [
  { path: "/dashboard", name: "Home", element: Main_Dashboard },
  { path: "/profile", name: "Profile", element: Profile },
  { path: "/notification", name: "Notification", element: Notification },
  { path: "/activation", name: "Activation", element: Activation },
  {
    path: "/activation/select-products",
    name: "Activation",
    element: Select_Products,
  },
  { path: "/kyc", name: "KYC", element: KYC },
  { path: "/add-member", name: "Add Member", element: Add_Member },
  { path: "/my-team", name: "My Team", element: My_Team },
  { path: "/binary-tree", name: "Binary Tree", element: Binary_Tree },
  {
    path: "/activate-member",
    name: "Activate Member",
    element: Activate_Member,
  },
  { path: "/income-reports", name: "Income Reports", element: Income_Reports },
  { path: "/wallet", name: "Wallet", element: Wallet },
  { path: "/add-funds", name: "Add Funds", element: Add_Funds },
  {
    path: "/add-funds/fund-request/funds-add",
    name: "Add Funds",
    element: Funds_Add,
  },
  { path: "/withdrawals", name: "Withdrawals", element: Withdrawals },
  {
    path: "/withdrawals/new-request",
    name: "Withdrawals",
    element: New_Request,
  },
  {
    path: "/my-orders",
    name: "My Orders",
    element: My_Orders,
  },
];

export default routes;
